import React, { useEffect, useState } from "react";
import { generateConclusion } from "../api/ruleEngine";

export interface ConclusionProps {
  findings: string[];
  patient: { age: string; sex: string };
  patientNote: string;
  clinicianOpinion: string;
  context: any[];
  onResult: (result: any | null) => void;
}

const Conclusion: React.FC<ConclusionProps> = ({
  findings,
  patient,
  patientNote,
  clinicianOpinion,
  context,
  onResult,
}) => {
  const [loading, setLoading] = useState(false);
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    let timer: number;

    if (loading) {
      timer = window.setInterval(() => {
        setDotCount((prev) => (prev + 1) % 4);
      }, 300);
    } else {
      setDotCount(0);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [loading]);

  const handleClick = async () => {
    onResult(null);
    setLoading(true);

    try {
      const result = await generateConclusion({
        findings,
        patient,
        patientNote,
        clinicianOpinion,
        context,
      });
      onResult(result);
    } catch (error) {
      console.error("Failed to generate diagnostic interpretation:", error);
      onResult({
        conclusion: [],
        comments: ["Failed to fetch diagnostic interpretation."],
      });
    } finally {
      setLoading(false);
    }
  };

  const loadingText = `Generating${".".repeat(dotCount)}`;

  return (
    <button onClick={handleClick} disabled={loading} className="app-button primary">
      {loading ? loadingText : "Generate Diagnostic Interpretation"}
    </button>
  );
};

export default Conclusion;

export function formatContextString(context: any[]): string {
  return JSON.stringify(context, null, 2);
}
